'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _creditCard = require('credit-card');

var _creditCard2 = _interopRequireDefault(_creditCard);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var creditCardErrors = function creditCardErrors(errors) {
  var remap = {
    validCardNumber: 'number',
    validExpiryMonth: 'expiryMonth',
    validExpiryYear: 'expiryYear',
    validCvv: 'cvv',
    isExpired: 'expired'
  };

  return _lodash2.default.mapKeys(errors, function (v, k) {
    return remap[k];
  });
};

var getCreditCardType = function getCreditCardType(number, opts) {
  return _creditCard2.default.determineCardType(number, opts);
};

var tryValidateCreditCard = function tryValidateCreditCard(value) {
  var card = _extends({
    cardType: _creditCard2.default.determineCardType(value.number)
  }, value);

  var result = _creditCard2.default.validate(card);
  var valid = _lodash2.default.pick(result, ['validCardNumber', 'validExpiryMonth', 'validExpiryYear', 'validCvv', 'isExpired']);

  valid.isExpired = !valid.isExpired;

  if (_lodash2.default.every(valid)) {
    return true;
  }

  var err = new Error('no valid credit card data');
  err.errors = creditCardErrors(valid);
  throw err;
};

var validateCreditCard = function validateCreditCard(value) {
  try {
    tryValidateCreditCard(value);
  } catch (e) {
    return _bluebird2.default.reject(e);
  }
  return _bluebird2.default.resolve(true);
};

exports.default = {
  validateCreditCard: validateCreditCard,
  getCreditCardType: getCreditCardType
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/helpers/payment.js
// module id = 412
// module chunks = 0